export const FAMILY_PLAN_DISCOUNT = 0.95



// WEBPACK FOOTER //
// ./src/constants/registration/choosePlan.js